import { AnchorHTMLAttributes, ButtonHTMLAttributes, CSSProperties, JSX, ReactNode } from 'react'

export type BasicProps = {
	children?: ReactNode
	className?: string
	style?: CSSProperties
}
//TODO: 컨벤션
import { HTMLAttributes } from 'react'
import { LinkProps } from 'next/link'

export type NullableString = string | boolean | undefined
type AnyProps = Record<string, any>
/**
 * Component T의 props 얻는 코드
 */
export type GetProps<T extends (...args: any) => any> = Parameters<T>[0]
// export type GetProps<T extends React.FC<AnyProps>> = Parameters<T>[0]
export type GetTProps<P, T extends React.FC<P>> = Parameters<T>[0]

/**
 * Component T의 props 중 한 객체의 타입
 */
export type GetPropsType<T extends React.FC<AnyProps>, P extends string> = NonNullable<GetProps<T>[P]>

/**
 * 찾는 대상을 매칭하는 대상에서 뽑아쓰는 코드임
 * @param mapEntries [key,value] 형태의 array
 * @param text 입력 값
 * @returns
 */
export const mapMatcher = <T>(mapEntries: [T, any][], text: string) => {
	// 이유는 명시적으로 키를 하나로 두기 위함임
	// 현재 구조는 키가 여러개 존재 할 수 있는 문제가 있음
	// 매칭 value를 분리하는 것도 방법
	const result = mapEntries.filter((item) => {
		return item.includes(text)
	})
	if (result && result.length > 0) return result[0][0]
	return
}

/**
 * 줄바꿈 없는 스타일 컴포넌트 선언하는 커링
 * @param init 자주 반복 사용하는 스타일
 * @returns
 */
export const setClassCurry =
	(...init: NullableString[]) =>
	(...classNames: NullableString[]) =>
		clc(...init, ...classNames)

/**
 * 찾는 대상을 매칭하는 대상에서 뽑아쓰는 코드임
 * any[] 를 순회해서 데이터를 찾는다
 * @param mapEntries [key,any[]] 형태의 array
 * @param text 입력 값
 * @returns
 */
export const keyBaseMapMatcher = <T>(mapEntries: [T, any[]][], text: any) => {
	const result = mapEntries.filter(([_, value]) => {
		return value.includes(text)
	})
	if (result && result.length > 0) return result[0][0]
	return
}

export const isServer = typeof window === 'undefined'
export const isClient = !(typeof window === 'undefined')
export const isDev = process.env.NODE_ENV === 'development'

/**
 * safety class Composer util
 * @example clc(styles.a,styles.b,'c')
 * @param classNames
 * @returns {string}
 */
export const clc = (...classNames: NullableString[]) => {
	const result = classNames.filter((text): text is string => typeof text === 'string')

	if (result.length === 0) {
		return undefined
	}
	return result.map((txt) => txt.trim()).join(' ')
}
export const clcDebug = (...classNames: NullableString[]) => {
	return classNames
		.filter((text): text is string => {
			if (typeof text === 'string') return typeof text === 'string'
			console.error('classDebugComposer text type is', typeof text)
			return false
		})
		.map((txt) => txt.trim())
		.join(' ')
}

// Shared Text Props

export type SpanProps<T> = JSX.IntrinsicElements['span'] & T
export type HeadingProps<T> = JSX.IntrinsicElements['h1'] & T
export type ParagraphProps<T> = JSX.IntrinsicElements['p'] & T
export type DivProps<T> = JSX.IntrinsicElements['div'] & T
export type AProps<T> = JSX.IntrinsicElements['a'] & T

export type BtnProps<T> = JSX.IntrinsicElements['button'] & T

export type LinkTagProps = LinkProps & JSX.IntrinsicElements['a']

export type BaseProps = JSX.IntrinsicElements
